import {PropertyBase} from "./PropertyBase";
declare let rednaoPDFInvoiceParams:any;

export class SliderProperty extends PropertyBase{



    public label:string='Text';
    private minValue:number=1;
    private maxValue:number=15;
    private defaultValue:number=1;
    protected InternalGetElement(): JQuery {
        return jQuery('<div style="padding-left:20px;width:100%;"><input type="text"  style="width:100%;"/></div>');
    }

    protected InternalGenerationCompleted($element:JQuery) {
        $element=$element.find('input');
        let currentValue:any=this.GetOptionValue();
        if(currentValue==null||currentValue=='')
            currentValue=this.defaultValue;

        currentValue=parseInt(currentValue);
        ($element as any).bootstrapSlider({
            min:this.minValue,
            max:this.maxValue,
            value:currentValue,
        });

        $element.on('slide',(e:any)=>{
            let value=e.value+'px';
            this.SetOptionValue(value);

        });




    }

    public SetMinValue(value:number)
    {
        this.minValue=value;
        return this;
    }

    public SetMaxValue(value:number)
    {
        this.maxValue=value;
        return this;
    }

    public SubRenderer(): React.ReactNode {
        return undefined;
    }



}

